import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { useField } from 'formik';
import { Dropdown } from '../Dropdown/Dropdown.js';

function DropdownField({
  name,
  onChange,
  validate,
  ...rest
}) {
  const [field, meta, {
    setValue,
    setError
  }] = useField({
    name,
    validate
  });
  function handleChange(value) {
    setValue(value);
    if (onChange) {
      onChange(value);
    }
  }
  function handleBlur(event) {
    if (field.onBlur) {
      field.onBlur(event);
    }
  }
  useEffect(() => {
    return () => {
      setValue(undefined);
      setError(undefined);
    };
  }, []);
  let errorMessage = '';
  if (meta.touched && meta.error) {
    errorMessage = meta.error;
  }
  return jsx(Dropdown, {
    error: errorMessage,
    ...field,
    ...rest,
    onBlur: handleBlur,
    onChange: handleChange
  });
}

export { DropdownField };
